import { Link } from "react-router-dom";
import { articles } from "@/mocks/gossip";

const CLIPS: { id: string; dur: string; note: string }[] = [
  { id: "juchang-zongyi-gaoshou", dur: "02:34", note: "高能片段合集" },
  { id: "yinyuewutai-shengyin", dur: "03:48", note: "纯享舞台" },
  { id: "qixiaying-dianshi-chaoxi", dur: "05:12", note: "本期预告" },
  { id: "yinyuejie-xianchang-chengyin", dur: "04:26", note: "现场实拍" },
];

export default function VideoStrip() {
  return (
    <section id="shipin" className="w-full scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8 lg:px-12">
        <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-video-fill" aria-hidden="true"></i>
              原片直连 · 来源可溯
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              视频专区 · 高能片段
            </h2>
          </div>
          <Link
            to="/category/zongyi"
            className="mt-2 inline-flex cursor-pointer items-center gap-1 self-start text-sm font-medium text-primary-600 hover:text-primary-700 md:mt-0"
          >
            查看更多 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CLIPS.map((c) => {
            const item = articles.find((a) => a.id === c.id);
            if (!item) return null;
            return (
              <Link
                key={c.id}
                to={`/detail/${item.id}`}
                className="group relative block overflow-hidden rounded-2xl border border-background-200/70 bg-background-100"
              >
                <div className="aspect-video w-full overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={`${item.title} 视频片段`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <span className="absolute right-2 top-2 rounded-md bg-foreground-950/70 px-1.5 py-0.5 text-[11px] font-semibold text-background-50 backdrop-blur">
                  {c.dur}
                </span>
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 shadow-lg transition-opacity duration-300 group-hover:opacity-100">
                    <i className="ri-play-fill ml-0.5 text-xl" aria-hidden="true"></i>
                  </span>
                </span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-3.5 pt-8">
                  <p className="text-[11px] font-semibold text-accent-300">{c.note}</p>
                  <p className="mt-1 line-clamp-2 text-sm font-bold leading-snug text-background-50">
                    {item.title}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}